module.exports = "<ng-transclude></ng-transclude>\r\n\r\n<dialog class=\"olyDialog olyDialog--dynamicContent\" name=\"{{dialogName}}\">\r\n    <a href=\"javascript:;\" class=\"olyDialog-close\" oly-dialog-close>\r\n        <span class=\"sr-only\">Close dialog</span> <i class=\"icon-close_x\"></i>\r\n    </a>\r\n    <oly-dynamic-content onload=\"showDialog()\" schedule-key=\"scheduleKey\"></oly-dynamic-content>\r\n</dialog>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/common/dynamiccontent/dynamic-content-dialog.directive.html
// module id = 604
// module chunks = 2